const DeleteToast = ({onConfirm,closeToast}) =>{
    const handleConfirm = () =>{
        // console.log('toast closed');
        onConfirm();
        closeToast();
    }

    const handleCancle = () =>{
        closeToast();
    }
    return(
        <>
            <div className="flex flex-col mt-2">
                <p className="text-gray-700">Are you sure ? </p>
                <p className="text-sm text-gray-300 mb-2">this action can't be undone</p>

                <div className="flex space-x-4">
                    <button
                        onClick={handleCancle} 
                        className="bg-gray-500 px-3 py-0.5 rounded-md hover:bg-gray-700 text-white">
                            No
                    </button>
                    <button 
                        onClick={handleConfirm}
                        className="bg-red-500 px-3 py-0.5 rounded-md hover:bg-red-700 text-white">
                            yes
                    </button>
                </div>
            </div>
        </>
    )
}

export default DeleteToast;